import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { RestaurantDashboardResponse } from './model/restaurant-dashboard-response';

@Injectable({
  providedIn: 'root',
})
export class RestaurantDashboardStateService {
  private readonly dataState$: BehaviorSubject<RestaurantDashboardResponse | null> =
    new BehaviorSubject<RestaurantDashboardResponse | null>(null);
  private readonly loadingState$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private readonly errorState$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private readonly selectedPeriodDaysState$: BehaviorSubject<number> = new BehaviorSubject<number>(7);

  public getData$(): Observable<RestaurantDashboardResponse | null> {
    return this.dataState$.asObservable();
  }

  public getData(): RestaurantDashboardResponse | null {
    return this.dataState$.getValue();
  }

  public setData(value: RestaurantDashboardResponse | null): void {
    this.dataState$.next(value);
  }

  public isLoading$(): Observable<boolean> {
    return this.loadingState$.asObservable();
  }

  public isLoading(): boolean {
    return this.loadingState$.getValue();
  }

  public setLoading(value: boolean): void {
    this.loadingState$.next(value);
  }

  public hasError$(): Observable<boolean> {
    return this.errorState$.asObservable();
  }

  public hasError(): boolean {
    return this.errorState$.getValue();
  }

  public setError(value: boolean): void {
    this.errorState$.next(value);
  }

  public selectedPeriodDays$(): Observable<number> {
    return this.selectedPeriodDaysState$.asObservable();
  }

  public getSelectedPeriodDays(): number {
    return this.selectedPeriodDaysState$.getValue();
  }

  public setSelectedPeriodDays(value: number): void {
    this.selectedPeriodDaysState$.next(value);
  }
}
